import React, { useEffect, useRef, useState, useCallback } from 'react';
import { pageAtom, isAuthAtom, topMessageAtom } from '../../State';
import { useRecoilState, useSetRecoilState } from 'recoil';

import './Header.css';
import Setting from '../Setting/Setting';
import { useParams, useNavigate } from 'react-router-dom';
// import { ReactComponent as SettingSVG } from '../Images/buttons/headerProfileButton.svg';
import { ReactComponent as CopyLinkSVG } from '../Images/buttons/linkCopyButton.svg';
//import { ReactComponent as CloseSVG } from '../Images/buttons/closePreButton.svg';
import { ReactComponent as SettingSVG } from '../Images/buttons/settingButton.svg';
import { ReactComponent as SmallSettingSVG } from '../Images/header/headerSettingSmall.svg';
import { ReactComponent as SmallBackgroundSVG } from '../Images/buttons/headerBackgroundButton.svg';
import { ReactComponent as SmallLinkSVG } from '../Images/header/headerLinkSmall.svg';
import { ReactComponent as CloseSVG } from '../Images/header/closeButtonHair.svg';
import { ReactComponent as CloseWhiteSVG } from '../Images/buttons/windowCloseButtonWhite.svg';
import { ReactComponent as MinSVG } from '../Images/buttons/windowMinimizeButtonWhite.svg';
import { ReactComponent as MaxSVG } from '../Images/buttons/windowMaxmizeButtonWhite.svg';
import { ReactComponent as LinkSVG } from '../Images/buttons/linkButton.svg';
import NFTDetail from '../NFT/NFTDetail';
import isElectron from '../../Global';
import ShowMessage from './ShowMessage';
import CountDown from './CountDown';
import { useTranslation } from 'react-i18next';
import { getImagePath } from '../Util/utils';
import isWindows from '../Util/isWindows';
import { isMobile } from 'react-device-detect';

export default function Header({
  isHome = false,
  url,
  isHairCheck = false,
  leaveCall,
  showSettingButton = true,
  isLive,
  isLiveViewer,
  isRecord,
}) {
  const [linkState, setLinkState] = useState(false);
  const [authState, setAuthState] = useRecoilState(isAuthAtom);
  const [pageState, setPageState] = useRecoilState(pageAtom);
  const setTopMessageState = useSetRecoilState(topMessageAtom);
  const [settingWrapState, setSettingWrapState] = useState(false);
  const navigate = useNavigate();
  const { t } = useTranslation();

  //URL取得
  const urlParam = useParams();
  var roomID = urlParam.id;

  //URLの語尾だけを取得
  if (url != null) {
    url = url.split('/').pop();
  } else {
    url = roomID;
  }

  //クリップボードにコピー
  const copyURL = (e) => {
    // e.preventDefault();
    var copiedURL = 'https://faceless.ooo/' + url;
    if (isLive) {
      copiedURL = 'https://faceless.ooo/l/' + url;
    }
    navigator.clipboard.writeText(copiedURL).then(
      function () {
        setTopMessageState({ type: 'copied', message: t('top.Copied Successfully') });
        setSettingWrapState(false);
      },
      function (err) {
        alert(err);
      },
    );
  };

  //背景ボタン
  const tapBackgroundButton = (e) => {
    setPageState('background');
    setSettingWrapState(false);
  };

  //閉じるボタン
  const closePage = () => {
    if (isMobile) {
      navigate('/');
    } else if (isElectron) {
      window.myapi.closeWindow();
    } else {
      if (authState) {
        navigate('/app');
      } else {
        window.location.href = 'https://faceless.ooo';
      }
    }
  };

  const closeSetting = () => {
    setSettingWrapState(false);
  };

  //設定一覧
  const showSettingWrap = async () => {
    if (isElectron && isHome) {
      //if (pageState == 'setting') return;
      setPageState('setting');
      const url = await window.myapi.getURL('setting');
      window.open(url, '_blank');
    } else {
      if (settingWrapState) {
        setSettingWrapState(false);
      } else {
        setSettingWrapState(true);
      }
    }
  };

  //設定ページ表示
  const showSetting = () => {
    setPageState('setting');
    setSettingWrapState(false);
  };

  // ヘッダーのダブルクリック
  const headerDoubleClick = () => {
    window.myapi.maxWindow();
    //window.myapi.closeWindow();
  };

  // ウィンドウを閉じる
  const closeWindow = () => {
    window.myapi.closeWindow();
  };

  // ウィンドウを相性化
  const minWindow = () => {
    window.myapi.minWindow();
  };

  return (
    <>
      {/* ヘッダーのメッセージ */}
      <ShowMessage />

      {/* 設定画面 */}
      {pageState == 'setting' && !isHome ? <Setting /> : ''}

      {/* NFT詳細画面 */}
      <NFTDetail />

      {/* ロゴ */}
      <header onDoubleClick={headerDoubleClick}>
        {/* ヘアチェック画面の場合 */}
        {isHairCheck && isMobile == false && (
          <div id="hairCheckClose" onClick={closePage}>
            <CloseSVG />
          </div>
        )}

        {isHairCheck && isMobile && (
          <div id="hairCheckClose" onClick={closePage}>
            <CloseWhiteSVG />
          </div>
        )}

        {isMobile && (
          <div id="hairCheckLink" onClick={copyURL}>
            <LinkSVG />
          </div>
        )}
        <div id="electronHeaderLogo">
          <img src={getImagePath() + '/header/logoDummyLeft.svg'} />
        </div>

        <div className="header-section"></div>

        <div className="header-section">
          {/* Windows Electronの場合 */}
          {isWindows && (
            <>
              <div id="electronWindowHeader2">
                <div className="electronWindowItem2" onClick={minWindow}>
                  <MinSVG />
                </div>

                {showSettingButton && (
                  <div className="electronWindowItem2" onClick={headerDoubleClick}>
                    <MaxSVG />
                  </div>
                )}
                <div className="electronWindowItem2" onClick={closeWindow}>
                  <CloseWhiteSVG />
                </div>
              </div>
            </>
          )}

          {showSettingButton && isLiveViewer == false && (
            <>
              {/* セッティングボタン部分 */}
              <div
                id="headerSetting"
                style={isWindows ? { position: 'absolute', left: '5px' } : { display: 'block' }}>
                <SettingSVG onClick={showSettingWrap} />

                {settingWrapState && (
                  <>
                    <div id="transparentBox" onClick={closeSetting}></div>
                    <div
                      id="settingDetail"
                      style={
                        isWindows
                          ? { position: 'absolute', left: '5px', right: 'auto' }
                          : { display: 'block' }
                      }>
                      <div className="settingDetailItem" onClick={showSetting}>
                        <div className="settingDetailImage">
                          <SmallSettingSVG />
                        </div>
                        <span>{t('setting.Setting')}</span>
                      </div>
                      <div className="settingDetailItem" onClick={tapBackgroundButton}>
                        <div className="settingDetailImage">
                          <SmallBackgroundSVG />
                        </div>
                        <span>{t('bottom.Background')}</span>
                      </div>
                      {isRecord == false && (
                        <div className="settingDetailItem" onClick={copyURL}>
                          <div className="settingDetailImage">
                            <SmallLinkSVG />
                          </div>
                          <span>{t('setting.Copy Meeting URL')}</span>
                        </div>
                      )}
                    </div>
                  </>
                )}
              </div>
            </>
          )}
        </div>
      </header>
    </>
  );
}
